import React, { useEffect } from 'react';
import { useStores } from 'util/mobx/stores';
import { observer } from 'mobx-react';
import MaterialLikeStorageLocations from 'components/MaterialLikeStorageLocations';
import MaterialStorageLocationsRightMenu from './SingleInstrumentStorageLocationsRightMenu';

interface Props {
  packageId: string;
}

const SingleInstrumentStorageLocations = observer(({ packageId }: Props) => {
  const { appNavigationStore, storageLocationStore } = useStores();

  // set the component for the right menu
  useEffect(() => {
    appNavigationStore.setRightMenuBuilder(() => {
      return <MaterialStorageLocationsRightMenu />;
    });
  }, [appNavigationStore]);

  useEffect(() => {
    return () => {
      storageLocationStore.refreshStore();
    };
  });

  appNavigationStore.useSubPageIdSetter('locations');

  return <MaterialLikeStorageLocations materialLikeOrPackageId={{ packageId }} />;
});

export default SingleInstrumentStorageLocations;
